<template>
    <div class="product-price">
        <p v-if="product.price_min > 0 && product.price_min < product.price_max"
           class="h6 text-secondary">
            A partir de
        </p>

        <div class="d-flex flex-wrap flex-align-center">
            <h2 class="h2 text-accent mx-0 my-0 mr flex-child-fixed">
                {{product.price_min > 0 ? product.price_min : product.price|formatMoney}}
            </h2>
            <p id="product-price-promo" v-if="priceBadge" class="badge-primary flex-child-fixed mr">
                {{priceBadge}}
            </p>
            <p v-if="$scope.IS_REGULAR_CUSTOMER && product.price_old && product.price < product.price_old"
               class="h6 text-secondary line-through mx-0 my-0 flex-child-fixed">
                {{product.price_old|formatMoney}}
            </p>

            <button v-if="!$scope.IS_REGULAR_CUSTOMER"
                    class="btn btn-sm btn-primary flex-child-fixed"
                    @click="$emit('scroll-to-wholesaler-buy')">
                Comprar
            </button>
        </div>

        <p class="product-price-installments" v-if="product.price >= 20 && $scope.IS_REGULAR_CUSTOMER">
            Até 4x {{Math.floor((product.price / 4) * 100) / 100|formatMoney}} sem juros
        </p>
    </div>
</template>

<script>
    export default {
        name: "ProductPagePrice",

        props: {
            product: {
                type: Object,
                required: true
            },
        },

        computed: {
            priceBadge() {
                if (this.product.promo_combo > 0 && this.displayPromoBadge) {
                    return 'Promo! ' + this.product.promo_name;
                } else if (this.product.promo_combo === 25 && this.displayPromoBadge) {
                    return 'Black Friday: ' + this.product.promo_name;
                } else if (this.product.discount && this.$scope.IS_REGULAR_CUSTOMER) {
                    return 'Promo! ' + this.product.discount + '% OFF';
                } else if (this.product.is_new && !this.product.promo_combo) {
                    return [5, 6, 8, 10, 14, 18, 31, 32, 36, 38, 42].indexOf((this.product.type || {}).id) !== -1 ? 'Novo' : 'Nova';
                } else {
                    return null;
                }
            },

            displayPromoBadge() {
                return this.$scope.IS_REGULAR_CUSTOMER && !this.product.promo_group;
            },
        }
    }
</script>